"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theme = exports.theme = exports.setTheme = exports.getTheme = exports.ThemeType = void 0;
const react_1 = __importDefault(require("react"));
const native_1 = require("styled-components/native");
const light_1 = require("./light");
const dark_1 = require("./dark");
const themes = {
    light: light_1.light,
    dark: dark_1.dark,
};
var ThemeType;
(function (ThemeType) {
    ThemeType["LIGHT"] = "light";
    ThemeType["DARK"] = "dark";
})(ThemeType = exports.ThemeType || (exports.ThemeType = {}));
let currentTheme = ThemeType.LIGHT;
exports.getTheme = () => currentTheme;
exports.setTheme = (newTheme) => {
    currentTheme = newTheme;
};
exports.theme = themes[currentTheme];
exports.Theme = (props) => {
    const { children, customTheme } = props;
    return (react_1.default.createElement(native_1.ThemeProvider, { theme: customTheme ? { ...exports.theme, ...customTheme } : exports.theme }, children));
};
